<template lang="pug">
v-container.px-0
	v-row
		v-col(lg="4" sm="6" cols="12" v-for="location in displayItems" :key="location.id")
			v-row(no-gutters)
				v-col.mr-3.shrink
					v-responsive(:aspect-ratio="4/3" :width="120" )
						nuxt-link.grey--text(:to="localePath({name: 'resorts-resort-location', params: {resort: location.resort.slug, location: location.slug}})")
							v-img(v-if="location.photos.length" :aspect-ratio="4/3" :width="120" :src="`${location.photos[0].url}?width=120`" :alt="location.photos[0].alt")
							v-img(v-else :aspect-ratio="4/3" :width="120")
								template(#placeholder)
									v-row.fill-height(align="center" style="background-color:rgb(245,245,245);")
										v-col.text-center
											v-icon image_not_supported


				v-col.grow(style="line-height:24px;")
					nuxt-link.d-block.font-weight-bold.subtitle-1(:to="localePath({name: 'resorts-resort-location', params: {resort: location.resort.slug, location: location.slug}})") {{location.name}}
					.d-block
						ws-icon(small color="grey") map-marker
						nuxt-link(color="grey" :to="localePath({name: 'resorts-resort', params: {resort: location.resort.slug}})") {{location.resort.name}}
					.d-block
						ws-icon(small color="grey") comments
						span(v-if="location.reviews.voteCount").grey--text {{$tc('area-location-list.label.{count}.reviews', location.reviews.voteCount, {count: location.reviews.voteCount})}}
						span(v-else)
							nuxt-link.grey--text(:to="localePath({name: 'resorts-resort-location', params: {resort: location.resort.slug, location: location.slug}})") {{$tc('area-location-list.label.write.first.review')}}
					v-rating(:value="location.averageRating" :color="location.averageRating? '#ffb400': ''" :background-color="location.averageRating? '#ffb400': ''" dense small readonly)

</template>
<script>
export default {
	props: {
		items: {
			type: Array,
			required: true
		},
		limit: {
			type: [Number, String],
			default: null
		}
	},
	data() {
		return {};
	},
	computed: {
		displayItems() {
			const sliced = this.limit
				? this.items.slice(0, parseInt(this.limit))
				: this.items;

			return sliced.map(item => {
				item.averageRating = item.reviews ? item.reviews.average : 0;
				return item;
			});
		}
	}
};
</script>
